import React  from "react";
import LogoMain from '../../assets/images/logo-main.png';

interface PropsI {
    children: React.ReactNode
}

const AuthLayout = ({ children }: PropsI) => {
    return (
        <div className="auth_layout">
            <div className="auth_bg">
                <div className="gradient-overlay">
                    <img src={LogoMain} alt=""/>
                </div>
                <div className="auth_bg_text">
                    <div className="auth_text_head">
                        PenSmart, <br/>
                        Be Independent
                    </div>
                    <div>
                        Lets help you build your life after retirement
                    </div>
                </div>
                <div className="auth_bg_footer">
                    &copy; 2024 NLPC PFA.
                </div>
            </div>
            <div className="auth_child">
                {/*
                <div className="logo_main">
                    <img src={LogoMain} alt="" />
                </div>
                */}
                {children}
            </div>
        </div>
    )
}

export default AuthLayout;